import Stores from './pages/stores.svelte';
import History from './pages/history.svelte';
import Login from './pages/login.svelte';
import Store from './pages/store.svelte';
import Note from './pages/note.svelte';

const mainRoutes = {

    '/' : Stores,

    '/login' : Login,

    '/history' : History,

    '/store/:store_id' : Store,

    '/store/:store_id/note/:note_id' : Note,

    '/note/:note_id' : Note,

    '*' : Stores,
}

export default mainRoutes;